import { ItemList } from '../../orm'

class AdminIncomingMollieSubscriptionList extends ItemList {
    getEntityKey() {
        return "admin/mollie_subscription"
    }
}

export const adminIncomingMollieSubscriptionList = new AdminIncomingMollieSubscriptionList("admin_mollie_subscription__default")
